import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { AgentStateSummaryData, EStateName } from '../agent-state-summary.model';
import { _stateColors } from 'src/app/dashboard/modules/current-agent-states/current-agent-states.models';

@Component({
  selector: 'cv-agent-state-summary-dialer-cell-renderer',
  templateUrl: './agent-state-summary-dialer-cell-renderer.component.html',
  styleUrl: './agent-state-summary-dialer-cell-renderer.component.scss'
})
export class AgentStateSummaryDialerCellRendererComponent implements AgRendererComponent {
  public params: any;
  public value: string;
  public dialerVisibility: boolean;
  color = "#000000";
  hideStatusIcon = 'inline-block';

  refresh(params: any): boolean {
    this.setRows(params);
    return true;
  }

  agInit(params: any): void {
    this.setRows(params);
  }

  setRows(params: any) {
    this.params = params;
    this.value = params.data.agentStateName;
    this.dialerVisibility = this.checkDialerVisibility(params.data.agentStateCategory);
    this.color = this.getStateColor(params.data);
    if (params.data.agentStateName === "Total") {
      this.hideStatusIcon = "none";
    }
  }

  checkDialerVisibility(value: EStateName): boolean {
    // Check if the value is "Awaiting Contacts" or "Working Contacts"
    if (value === EStateName.AwaitingContacts || value === EStateName.WorkingContacts) {
      return true;
    } else {
      return false;
    }
  }

  getStateColor(data: AgentStateSummaryData) {
    if (data !== undefined) {
      switch (data.agentStateCategory) {
        case EStateName.Available:
          return _stateColors.green;
        case EStateName.WorkingContacts:
          return _stateColors.purple;
        case EStateName.AwaitingContacts:
          return _stateColors.yellow;
        case EStateName.Ended:
          return _stateColors.gray;
        case EStateName.Created:
          return _stateColors.blue;
        case EStateName.Unavailable:
        default: // Probably a custom one.
          return _stateColors.red;
      }
    }
    return _stateColors.red;
  }
}
